module.exports = __webpack_public_path__ + "static/media/iPhoneX.c7c82798.png";